import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "src/app/services/auth/auth.service";

@Injectable()
export class AuthGuard {
  constructor(private _router: Router,
              private _auth: AuthService) {
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this._auth.isAuthenticated()) {
      console.log('statue url:',state.url)
      this._router.navigate(['/auth', 'login'])
        .then(() => {
          this._auth.interruptedUrl = state.url;
        });
    }
    return this._auth.isAuthenticated();
  }

  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean  {
    return this.canActivateChild(childRoute, state);
  }


}
